import "./modal.scss";

import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import ModalDetailView from "../../components/modal/ModalDetailView";
import ModalMasterView from "../../components/modal/ModalMasterView";
import NavigationToolbar from "../../components/navigationToolbar";
import Dimensions from "../../constants/styles/dimensions";
import { PropTypeShapes } from "../../types";
import { asPortalChild } from "../portal/asPortalChild";
import { withScreenContext } from "../screen/ScreenContext";
import ModalBody from "./ModalBody";
import { withModalSizeContext } from "./ModalSizeContext";

class ModalMasterDetailView extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedItem: null
    };
    this.selectItem = this.selectItem.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.addItem = this.addItem.bind(this);
    this.moveItemAtIndex = this.moveItemAtIndex.bind(this);
  }

  componentWillMount() {
    //#!if iOS !== true
    this.selectItemAtIndex(this.props, 0);
    //#!endif
  }

  componentWillReceiveProps(nextProps) {
    // Props have been updated.
    // So we may need to re-select an item.
    // First, get a list of old and next items
    const oldItems = this.props.items.map(i => i.value);
    const nextItems = nextProps.items.map(i => i.value);

    // If there is a new item that didn't exist last time, then we should select
    // it straight away.
    const newItems = nextItems.filter(i => oldItems.indexOf(i) === -1);
    if (newItems.length) {
      const oldItemLabels = this.props.items.map(i => i.label);
      const nextItemLabels = nextProps.items.map(i => i.label);
      const newItemNames = nextItemLabels.filter(i => oldItemLabels.indexOf(i) === -1);
      if (newItemNames.length) {
        const newIndex = nextItemLabels.indexOf(newItemNames[0]);
        this.selectItemAtIndex(nextProps, newIndex);
      } else {
        this.selectItem(newItems[0]);
      }
      return;
    }

    // Otherwise, nothing new has been added. Check to make sure the old selected item
    // still exists.
    if (!isNil(this.state.selectedItem) && nextItems.indexOf(this.state.selectedItem) >= 0) {
      // Found the item, nothing to see here
      return;
    }

    // Item doesn't exist any more.
    // Find index in old props and select the new item at that index.
    const oldIndex = Math.min(
      Math.max(oldItems.indexOf(this.state.selectedItem), 0),
      //limit the minimum index to 0
      Math.max(nextProps.items.length - 1, 0)
    );
    //#!if iOS === true
// this.selectItem(null);
    //#!else
    this.selectItemAtIndex(nextProps, oldIndex);
    //#!endif
  }

  selectItemAtIndex(props, index) {
    if (props.items.length > index) {
      this.selectItem(props.items[index].value);
    } else {
      this.selectItem(null);
    }
  }

  selectItem(val) {
    this.setState({ selectedItem: val });
  }

  deleteItem() {
    this.props.onDeleteClick(this.state.selectedItem);
  }

  addItem(index) {
    this.props.onAddClick(index);
  }

  renderPortal(child) {
    return (
      <div className={`iosModalContentWrap`}>
        <NavigationToolbar
          title="Edit"
          showBack={true}
          showBackArrow={true}
          onBackClick={() => this.selectItem(null)}
          backText={this.props.backText ? this.props.backText : "Back"}
          showNext={true}
          onNextClick={this.props.onDoneClick}
          nextText={"Done"}
          nextDisabled={this.props.doneDisabled}
          flexLeft={1}
          flexCenter={3}
          flexRight={1}
        />
        <ModalBody>
          <ModalDetailView>{child}</ModalDetailView>
        </ModalBody>
        {this.props.footer ? this.props.footer : null}
      </div>
    );
  }

  moveItemAtIndex(fromIndex, toIndex) {
    //#!if iOS !== true
    if (this.props.itemsUseIndexAsId) {
      this.selectItemAtIndex(this.props, toIndex);
    } else {
      this.selectItemAtIndex(this.props, fromIndex);
    }
    //#!endif
    this.props.onMoveItemAtIndex(fromIndex, toIndex);
  }

  render() {
    const child = React.cloneElement(React.Children.only(this.props.children), {
      selectedItem: this.state.selectedItem,
      canDelete: !isNil(this.state.selectedItem)
        ? this.props.items.find(i => i.value === this.state.selectedItem).canDelete
        : false,
      onDeleteClick: this.props.onDeleteClick ? this.deleteItem : null
    });
    // When minHeight is NOT disabled
    // Master Detail view is always forced to be as large as possible
    const styleObj = {
      minHeight: this.props.disableMinHeight ? "auto" : this.props.maxHeight - Dimensions.MODAL_MASTER_DETAIL_TOP_MARGIN
    };

    let className = "modalMasterDetail";
    let detailView = null;
    //#!if iOS === true
// className = "";
// detailView = !isNil(this.state.selectedItem) ? asPortalChild(this.renderPortal(child)) : null;
    //#!else
    detailView = <ModalDetailView>{child}</ModalDetailView>;
    //#!endif

    if (this.props.disabled) {
      className += " disabled";
    }

    return (
      <div className={className} style={styleObj}>
        <ModalMasterView
          disabled={this.props.disabled}
          items={this.props.items}
          selectedItem={this.state.selectedItem}
          onItemSelect={this.selectItem}
          onAddClick={this.props.onAddClick ? this.addItem : null}
          onDeleteClick={this.props.onDeleteClick ? this.deleteItem : null}
          allowDrag={this.props.allowDrag}
          lockTopItemForDrag={this.props.lockTopItemForDrag}
          lockBottomItemForDrag={this.props.lockBottomItemForDrag}
          onMoveItemAtIndex={this.moveItemAtIndex}
        />
        {detailView}
      </div>
    );
  }
}

ModalMasterDetailView.propTypes = {
  disabled: PropTypes.bool,
  items: PropTypeShapes.listOptionArray.isRequired,
  children: PropTypes.element.isRequired,
  onAddClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  // Dragging to re-order items
  allowDrag: PropTypes.bool,
  lockTopItemForDrag: PropTypes.bool,
  lockBottomItemForDrag: PropTypes.bool,
  onMoveItemAtIndex: PropTypes.func,
  backText: PropTypes.string,
  disableMinHeight: PropTypes.bool,
  itemsUseIndexAsId: PropTypes.bool.isRequired,

  // From ModalSizeContext
  maxHeight: PropTypes.number.isRequired,
  fixedHeight: PropTypes.number,

  //#!if iOS === true
// onDoneClick: PropTypes.func.isRequired,
// doneDisabled: PropTypes.bool,
// footer: PropTypes.element,
// 
  // From withScreenContext
// screenContext: PropTypes.object
  //#!endif
};

let exportedView = withModalSizeContext(ModalMasterDetailView);
//#!if iOS === true
// exportedView = withScreenContext(withModalSizeContext(ModalMasterDetailView));
//#!endif
export default exportedView;
